import script from "./HTwbCardCollect.vue?vue&type=script&setup=true&lang=js"
export * from "./HTwbCardCollect.vue?vue&type=script&setup=true&lang=js"

import "./HTwbCardCollect.vue?vue&type=style&index=0&id=f57548fe&lang=less"

const __exports__ = script;

export default __exports__